module.exports = __webpack_public_path__ + "img/block-teal.07b26dff.png";